import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export interface SubscriptionAlertState {
  open: boolean;
  expired: boolean;
  limitReached: boolean;
}

const initialState: SubscriptionAlertState = {
  open: false,
  expired: false,
  limitReached: false,
};

export const subscriptionAlertSlice = createSlice({
  name: "subscriptionAlert",
  initialState,
  reducers: {
    setOpen: (state, action: PayloadAction<boolean>) => {
      state.open = action.payload;
    },
    setExpired: (state, action: PayloadAction<boolean>) => {
      state.expired = action.payload;
    },
    setLimitReached: (state, action: PayloadAction<boolean>) => {
      state.limitReached = action.payload;
    },
  },
});

export const { setExpired, setLimitReached, setOpen } =
  subscriptionAlertSlice.actions;

export default subscriptionAlertSlice.reducer;
